// extracted by mini-css-extract-plugin
export var answerBox = "thread-module--answer-box--20854";
export var back = "thread-module--back--56231";
export var backIcon = "thread-module--back-icon--8f860";
export var buttonAnswer = "thread-module--button-answer--15c8e";
export var commentBox = "thread-module--comment-box--6b51e";
export var commentTree = "thread-module--comment-tree--7c9e0";
export var commentsContainer = "thread-module--comments-container--99680";
export var container = "thread-module--container--af949";
export var content = "thread-module--content--fabd8";
export var details = "thread-module--details--1cf62";
export var favorite = "thread-module--favorite--fb4da";
export var fixedLoader = "thread-module--fixed-loader--47e30";
export var header = "thread-module--header--35c4e";
export var heartIcon = "thread-module--heart-icon--dbb08";
export var likeButton = "thread-module--like-button--145c7";
export var loader = "thread-module--loader--9ac88";
export var loading = "thread-module--loading--57151";
export var mainAnswerForm = "thread-module--main-answer-form--1965d";
export var message = "thread-module--message--c7419";
export var meta = "thread-module--meta--c1be4";
export var moreButton = "thread-module--more-button--592de";
export var title = "thread-module--title--ba5c5";
export var toggleLoading = "thread-module--toggle-loading--15059";